interface RankingItem {
  rank: number;
  title: string;
  tags: string[];
  hot: string;
  change: 'up' | 'down' | 'new' | 'same';
}

const rankingItems: RankingItem[] = [
  { rank: 1, title: '星际远征', tags: ['4K', '科幻'], hot: '9.8', change: 'same' },
  { rank: 2, title: '长安十二时辰', tags: ['4K', '历史'], hot: '9.6', change: 'up' },
  { rank: 3, title: '暗夜追踪', tags: ['蓝光', '悬疑'], hot: '9.4', change: 'up' },
  { rank: 4, title: '极限营救', tags: ['4K', '动作'], hot: '9.3', change: 'down' },
  { rank: 5, title: '花落知多少', tags: ['4K', '剧情'], hot: '9.1', change: 'new' },
];

const changeIcons: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-emerald-500' },
  down: { icon: 'ri-arrow-down-line', color: 'text-red-400' },
  new: { icon: 'ri-flashlight-line', color: 'text-accent-500' },
  same: { icon: 'ri-subtract-line', color: 'text-foreground-400' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-accent-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-fire-line text-accent-600 text-sm"></i>
              <span className="text-accent-700 text-xs font-medium">实时热度</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              热播榜单
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              麻花影院当前热度最高的超清大片实时排行
            </p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 px-5 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-100/60 transition-colors duration-150 cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                  {item.rank <= 3 ? (
                    <span className={`font-heading text-xl font-bold ${
                      item.rank === 1 ? 'text-amber-500' :
                      item.rank === 2 ? 'text-foreground-400' :
                      'text-amber-700'
                    }`}>
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-foreground-400 font-semibold text-sm">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading text-foreground-900 font-semibold text-sm">{item.title}</h3>
                    <div className="flex flex-wrap gap-1">
                      {item.tags.map((tag) => (
                        <span key={tag} className="bg-secondary-100 text-secondary-700 text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-foreground-900 font-heading font-bold text-sm">{item.hot}</span>
                  <span className={`flex items-center text-xs ${changeIcons[item.change].color}`}>
                    <i className={changeIcons[item.change].icon}></i>
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-6">
            <a
              href="#cards"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer"
            >
              查看完整榜单
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}